import { useEffect, useRef } from 'react';

function useIdleTimer(ms, onIdle) {
  const idleTimerRef = useRef(null);

  const resetTimer = () => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }

    // Guarda la hora actual como la última actividad en localStorage
    const now = Date.now();
    localStorage.setItem('lastActivity', now.toString());

    idleTimerRef.current = setTimeout(() => {
      const lastActivityStored = Number(localStorage.getItem('lastActivity'));
      const currentTime = Date.now();

      if (currentTime - lastActivityStored >= ms) {
        onIdle();
      }
    }, ms);
  };

  useEffect(() => {
    const checkActivity = () => {
      const lastActivityStored = Number(localStorage.getItem('lastActivity'));
      if (Date.now() - lastActivityStored >= ms) {
        onIdle();
      }
    };

    // Establece un intervalo para verificar la actividad en localStorage
    const activityCheckInterval = setInterval(checkActivity, 10000); 

    resetTimer();

    const events = ['mousemove', 'mousedown', 'keypress', 'touchmove', 'scroll'];
    events.forEach(e => {
      window.addEventListener(e, resetTimer);
    });

    return () => {
      clearInterval(activityCheckInterval);
      clearTimeout(idleTimerRef.current);
      events.forEach(e => {
        window.removeEventListener(e, resetTimer);
      });
    };
  }, [ms, onIdle]); // eslint-disable-line react-hooks/exhaustive-deps

  return resetTimer;
}

export default useIdleTimer;
